import type { SxProps, Theme } from "@mui/material";
import { NEUTRAL, SURFACE } from "../../../../theme/tokens";

// The dense config-table chrome and borderless in-cell inputs live in
// `components/UIToolkit/Tables/ConfigTable/configTableSx.ts` (DAT-905).

// Height of the form's standard MUI medium controls, so shorter adjacent controls can
// center against the field rather than its reserved-helper-text column.
export const INPUT_FIELD_HEIGHT_PX = 40;

// Shared neutral "ground" band behind the side-laid Dept Config sections. Wrap the
// contiguous side-laid `SettingsSection`s in this; full-width tables stay outside it.
export const SIDE_LAID_GROUND_SX: SxProps<Theme> = (theme) => ({
	display: "flex",
	flexDirection: "column",
	width: "100%",
	backgroundColor: NEUTRAL[50],
	borderRadius: `${Number(theme.shape.borderRadius) * 1.5}px`,
	px: { xs: 2, md: 3 },
});

// Spreadable base for a hairline-bordered subgroup on the white SettingsSection panel.
// Stays on SURFACE (not NEUTRAL[50]) so it reads as a clean subgroup, not a muddy inset.
export const SUBGROUP_BORDERED_SX_BASE = {
	border: `1px solid ${NEUTRAL[200]}`,
	borderRadius: 1.5,
	backgroundColor: SURFACE,
} as const;

// Ready-to-use bordered subgroup with a padded vertical stack. For custom layouts,
// spread SUBGROUP_BORDERED_SX_BASE instead.
export const SUBGROUP_BORDERED_SX: SxProps<Theme> = {
	...SUBGROUP_BORDERED_SX_BASE,
	display: "flex",
	flexDirection: "column",
	gap: 1,
	p: 1.5,
};
